import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, Card } from "react-bootstrap";
import SuperCorrectiveActionReport from "./SuperCorrectiveActionReport";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate";

function NcReportModal_2({ show, handleClose, productId,refreshParent }) {
  const [superCorrectiveActionReport, setSuperCorrectiveActionReport] =
    useState(false);
  const [productList, setProductList] = useState(null);

  const [formData, setFormData] = useState({
    quantity_inspected: "",
    quantity_on_hold: "",
    quantity_passed: "",
    unit: "pcs",
    nc_reason: "",
  });

  const fetchShowncreportList = async () => {
    const token = getAuthToken();
    if (!token || !productId) return;

    try {
      const res = await axios.get(
        `${config.API}/supervisor/showncreport/${productId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const product = res.data?.product || null;
      setProductList(product);

      setFormData({
        quantity_inspected: product?.quantity_inspected || "",
        quantity_on_hold: product?.quantity_hold || "",
        quantity_passed: product?.quantity_passed || "",
        unit: "pcs",
        nc_reason: product?.nc_reason || "",
      });
    } catch (err) {
      toast.error("Failed to load NC report");
    }
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) return toast.error("Authentication token missing!");

    try {
      const res = await axios.post(
        `${config.API}/supervisor/showncreport/${productId}`,
        { ...formData, status: "validated" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(res.data?.message || "Report validated successfully");
      await refreshParent();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (show) fetchShowncreportList();
  }, [show, productId]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
        <Modal.Body className="p-5">
          <strong className="fs-4">NC Report</strong>

          <Card className="mb-4 bg-light mt-4">
            <Card.Body>
              <Row>
                <Col md={6}>
                  <strong>Product Name:</strong> {productList?.product?.name}
                </Col>
                <Col md={6}>
                  <strong>Product ID:</strong>{" "}
                  {productList?.product?.product_code}
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md={6}>
                  <strong>Qty NC:</strong> {productList?.nc_count || 0}
                </Col>
                <Col md={6}>
                  <strong>Report Date:</strong>{" "}
                  {productList?.created_at
                    ? formatDate(productList.created_at)
                    : "-"}
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md={6}>
                  <strong>Reported by:</strong> {productList?.user?.name}
                </Col>
                <Col md={6}>
                  <strong>NC Type:</strong> {productList?.reason}
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>Quantity Inspected</Form.Label>
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                value={formData.quantity_inspected}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    quantity_inspected: e.target.value,
                  })
                }
              />
            </Col>

            <Col md={2}>
              <Form.Label>Unit</Form.Label>
            </Col>
            <Col md={4}>
              <Form.Select
                value={formData.unit}
                onChange={(e) =>
                  setFormData({ ...formData, unit: e.target.value })
                }
              >
                <option value="pcs">pcs</option>
                <option value="kg">kg</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>Quantity on Hold</Form.Label>
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                value={formData.quantity_on_hold}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    quantity_on_hold: e.target.value,
                  })
                }
              />
            </Col>

            <Col md={3}>
              <Form.Label>Quantity Passed</Form.Label>
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                value={formData.quantity_passed}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    quantity_passed: e.target.value,
                  })
                }
              />
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={2}>
              <strong>NC Reason</strong>
            </Col>
            <Col md={10}>
              <Form.Control
                as="textarea"
                rows={4}
                value={formData.nc_reason}
                onChange={(e) =>
                  setFormData({ ...formData, nc_reason: e.target.value })
                }
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="border-0 mb-4">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="outline-dark"
            onClick={() => setSuperCorrectiveActionReport(true)}
          >
            Add Corrective Measure
          </Button>
          <Button variant="dark" onClick={handleSubmit}>
            Validate
          </Button>
        </Modal.Footer>
      </Modal>

      <SuperCorrectiveActionReport
        productId={productId}
        show={superCorrectiveActionReport}
        handleClose={() => setSuperCorrectiveActionReport(false)}
      />
    </>
  );
}

export default NcReportModal_2;